export const formatedNumber = (num) => {
    return num !== undefined
        ? parseFloat(num).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        : '';
};